import { useNextTask, useTasks, useTodoTasks } from '../utils/hooks';
import { Navigate, useParams } from 'react-router-dom';
import { ResolverIntroGeneric } from './IntroGeneric';
import { ResolverIntroSetup } from './IntroSetup';
import { NotFound } from '../../NotFound';
import { ResolverRouteParams } from '../utils/types';

export const ResolverIntro = () => {
  const { resolverType } = useParams<ResolverRouteParams>();
  const tasks = useTasks();
  const todoTasks = useTodoTasks();
  const nextTask = useNextTask();

  if (tasks.length === 0) {
    /**
     * TODO: We need a 404-like screen here. It's possible that given a
     * particular query you will get no tasks back from the API. This isn't
     * really a 404 but we need to say that there's nothing to do and some where
     * to go.
     */
    return <NotFound />;
  }

  if (todoTasks.length < tasks.length && nextTask) {
    return <Navigate to={`task/${nextTask.id}`} replace />;
  }

  if (todoTasks.length === 0) {
    return <Navigate to="complete" replace />;
  }

  if (tasks.length === 1) {
    return <Navigate to={`task/${tasks[0].id}`} replace />;
  }

  return (
    <div className="h-[calc(100vh-64px)] p-6">
      <div className="flex h-full items-center justify-center border bg-white">
        <div className="max-h-full w-full shrink overflow-y-auto p-6">
          {resolverType === 'setup' ? (
            <ResolverIntroSetup />
          ) : (
            <ResolverIntroGeneric />
          )}
        </div>
      </div>
    </div>
  );
};
